import { defineComponent } from "vue";
import useInputs from "@/components/general/Inputs";
const { Select, Date, Input } = useInputs();
export default defineComponent({
  name: "TableFilter",
  components: {
    Select,
    Date,
    Input,
  },
  data: () => ({
    valuesFilter: {
      selectTicketType: null,
      selectManagement: null,
      selectTypeManagement: null,
      start_date: "",
      end_date: "",
      license_id: "",
    },
  }),
  computed: {
    // ## VALOR INCIAL POR DEFECTO PARA LOS SELECTORES
    optionDefault() {
      return {
        value: null,
        text: "Selecciona una opción",
        disabled: true,
      };
    },
    // ## OPCIONES DE LOS TIPOS DE TIQUETES
    optionsTicketType() {
      const values = [
        {
          id: "Nacional",
          name: "Nacionales",
        },
        {
          id: "Internacional",
          name: "Internacionales",
        },
      ];
      return this.setSelectors(values);
    },
    // ## OPCIONES DE LAS GESTIONES DE TIQUETES
    optionsManagement() {
      const values = [
        {
          id: "closed",
          name: "Gestionados",
        },
        {
          id: "pending",
          name: "Sin gestionar",
        },
      ];
      return this.setSelectors(values);
    },
    // ## OPCIONES DE QUIEN GESTIONA LOS PERMISOS
    optionsTypeManagement() {
      const values = [
        {
          id: "automatic",
          name: "Automática",
        },
        {
          id: "by-approver",
          name: "Por aprobador",
        },
      ];
      return this.setSelectors(values);
    },
    isDisabled() {
      const me = this;
      return Object.values(me.valuesFilter).some(
        (filter) => filter !== null && filter !== ""
      );
    },
  },
  watch: {
    valuesFilter: {
      handler() {
        const me = this;
        me.emitEvent();
      },
      deep: true,
    },
  },
  methods: {
    // ## RECIBE Y RETORNA LOS VALORES DE LOS SELECTORES
    setSelectors(values = []) {
      return [...values];
    },
    // ## LIMPIA TODOS LOS FILTROS EN CASO DE QUE ESTEN SELECCIONADOS
    clearFilters() {
      const me = this;
      me.valuesFilter = {
        selectTicketType: null,
        selectManagement: null,
        selectTypeManagement: null,
        start_date: "",
        end_date: "",
        license_id: "",
      };
      me.emitEvent();
    },
    // ## EMITE LOS EVENTOS DEL CAMBIO AL PADRE
    emitEvent() {
      const me = this;
      const values = {
        types_of_approvals: me.valuesFilter.selectTicketType?.id || null,
        ticket_management: me.valuesFilter.selectManagement?.id || null,
        type_of_approval: me.valuesFilter.selectTypeManagement?.id || null,
        start_date: me.valuesFilter.start_date || null,
        end_date: me.valuesFilter.end_date || null,
        license_id: me.valuesFilter.license_id || null,
      };
      me.$emit("update:selects", values);
    },
    // ## VALIDA LA RUTA Y ASIGNA LOS VALORES CORRESPONDIENTES
    validRoute() {
      const me = this;
      const params = me.$route.query;
      if (params?.types_of_approvals) {
        const record = me.optionsTicketType.find(
          (item) => item.id === params.types_of_approvals
        );
        me.valuesFilter.selectTicketType = record;
      }

      if (params?.ticket_management) {
        const record = me.optionsManagement.find(
          (item) => item.id === params.ticket_management
        );
        me.valuesFilter.selectManagement = record;
      }

      if (params?.type_of_approval) {
        const record = me.optionsTypeManagement.find(
          (item) => item.id === params.type_of_approval
        );
        me.valuesFilter.selectTypeManagement = record;
      }

      if (params?.start_date) {
        me.valuesFilter.start_date = params.start_date;
      }

      if (params?.end_date) {
        me.valuesFilter.end_date = params.end_date;
      }

      if (params?.license_id) {
        me.valuesFilter.license_id = params.license_id;
      }
    },
  },
  mounted() {
    this.validRoute();
  },
});
